import React from 'react'
import {trackUser, trackEvent} from 'react-with-analytics'

import {ContactData} from '../components/'

trackUser('@username')
trackEvent('Site', 'Contact', 'Contact PAge')

const Contact = () => (
    <React.Fragment>
        <ContactData />
    </React.Fragment>
)

export default Contact



// WEBPACK FOOTER //
// ./src/pages/contact.js